<template>
  <Transition name="slide">
    <FilterListInner v-if="get_filterOptions.isOpen" />
  </Transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterListInner from '@/components/Lobby/FilterList/FilterListInner'

export default {
  name: 'FilterList',
  components: {
    FilterListInner,
  },
  computed: {
    ...mapGetters('lobby', [
      'get_filterOptions',
    ]),
  },
  watch: {
    '$route.path'() {
      this.write_filterOptions({ reset: true })
      this.fetch_presetFilters({ reset: true })
    },
  },
  methods: {
    ...mapActions('lobby', ['write_filterOptions', 'fetch_presetFilters']),
  },
}
</script>

<style lang="scss" scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s linear;

  ::v-deep {
    .filter-list__overlay,
    .filter-list__wrapper {
      transition: all 0.3s linear;
    }
  }
}

.slide-enter-to,
.slide-leave {
  ::v-deep {
    .filter-list__overlay {
      opacity: 1;
    }

    .filter-list__wrapper {
      transform: translateX(0%);
    }
  }
}

.slide-enter,
.slide-leave-to {
  ::v-deep {
    .filter-list__overlay {
      opacity: 0;
    }

    .filter-list__wrapper {
      transform: translateX(100%);
    }
  }
}
</style>
